const TOKEN_KEY = "estef_admin_token";

export const getAdminToken = () => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(TOKEN_KEY);
};

export const setAdminToken = (token: string) => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(TOKEN_KEY, token);
};

export const clearAdminToken = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(TOKEN_KEY);
};

export const fetchAdmin = (
  input: RequestInfo | URL,
  init: RequestInit = {},
) => {
  const headers = new Headers(init.headers);
  const token = getAdminToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
};
